export const LOAD_SPARCLE_CARD = "analyticalReducer/LOAD_SPARCLE_CARD";
export const SET_SERVICE_BY_TYPES = "analyticalReducer/SET_SERVICE_BY_TYPES";
export const SET_SERVICE_BY_STATUS = "analyticalReducer/SET_SERVICE_BY_STATUS";
export const SET_CUSTOMER_REVIEWS = "analyticalReducer/SET_CUSTOMER_REVIEWS";
export const SET_SERVICE_BY_BRANCH = "analyticalReducer/SET_SERVICE_BY_BRANCH";
export const SET_AVERAGE_CHART_DATA = "analyticalReducer/SET_AVERAGE_CHART_DATA";
export const SET_COST_PRICE_DATA = "analyticalReducer/SET_COST_PRICE_DATA";
export const SET_RECEIVABLE_CHART_DATA = "analyticalReducer/SET_RECEIVABLE_CHART_DATA";
export const SET_SUPPLIER_DEBT_CHART_DATA = "analyticalReducer/SET_SUPPLIER_DEBT_CHART_DATA";
export const SET_DEBTS_CHART_DATA = "analyticalReducer/SET_DEBTS_CHART_DATA";
export const SET_RECEIVABLE_CUSTOMER_PIE_CHART_DATA = "analyticalReducer/SET_RECEIVABLE_CUSTOMER_PIE_CHART_DATA";
export const SET_INCOME_EXPENSE_CHART_DATA = "analyticalReducer/SET_INCOME_EXPENSE_CHART_DATA";
export const SET_INCOME_EXPENSE_PIE_CHART_DATA = "analyticalReducer/SET_INCOME_EXPENSE_PIE_CHART_DATA";
export const ON_PRESS_TOP_PRODUCT_DROPDOWN =
  "analyticalReducer/ON_PRESS_TOP_PRODUCT_DROPDOWN";
export const ON_PRESS_REFERRALS_DROPDOWN =
  "analyticalReducer/ON_PRESS_REFERRALS_DROPDOWN";
export const ON_PRESS_TOTAL_REVENUE_DROPDOWN =
  "analyticalReducer/ON_PRESS_TOTAL_REVENUE_DROPDOWN";
export const ON_PRESS_DATA_MANAGED_DROPDOWN =
  "analyticalReducer/ON_PRESS_DATA_MANAGED_DROPDOWN";
export const ON_PRESS_RECENT_CHAT_DROPDOWN =
  "analyticalReducer/ON_PRESS_RECENT_CHAT_DROPDOWN";
export const FACEBOOK_PROGRESS_BAR = "analyticalReducer/FACEBOOK_PROGRESS_BAR";
export const TWITTER_PROGRESS_BAR = "analyticalReducer/TWITTER_PROGRESS_BAR";
export const SEARCH_PROGRESS_BAR = "analyticalReducer/SEARCH_PROGRESS_BAR";
export const SET_PROFIT_DATA = "analyticalReducer/SET_PROFIT_DATA";
export const AFFILIATES_PROGRESS_BAR =
  "analyticalReducer/AFFILIATES_PROGRESS_BAR";

export const loadSparcleCard = (sparkleCardData) => (disptch) => {
  disptch({
    type: LOAD_SPARCLE_CARD,
    payload: sparkleCardData,
  });
};
export const setServiceByTypes = (disptch) => ({
  type: SET_SERVICE_BY_TYPES,
  payload: disptch,
});
export const setServiceByStatus = (disptch) => ({
  type: SET_SERVICE_BY_STATUS,
  payload: disptch,
});
export const setServiceByBranch = (disptch) => ({
  type: SET_SERVICE_BY_BRANCH,
  payload: disptch,
});
export const setCustomerReviews = (disptch) => ({
  type: SET_CUSTOMER_REVIEWS,
  payload: disptch,
});
export const setAverageChartData = (data) => ({
  type: SET_AVERAGE_CHART_DATA,
  payload: data,
});
export const setCostPriceData = (data) => ({
  type: SET_COST_PRICE_DATA,
  payload: data,
});
export const setReceivableChartData = (data) => ({
  type: SET_RECEIVABLE_CHART_DATA,
  payload: data,
});
export const setDebtsChartData = (data) => ({
  type: SET_DEBTS_CHART_DATA,
  payload: data,
});
export const setSupplierDebtsChartData = (data) => ({
  type: SET_SUPPLIER_DEBT_CHART_DATA,
  payload: data,
});
export const setIncomeExpenseChartData = (data) => ({
  type: SET_INCOME_EXPENSE_CHART_DATA,
  payload: data,
});
export const setIncomeExpensePieChartData = (data) => ({
  type: SET_INCOME_EXPENSE_PIE_CHART_DATA,
  payload: data,
});
export const setReceivableCustomersChartData = (data) => ({
  type: SET_RECEIVABLE_CUSTOMER_PIE_CHART_DATA,
  payload: data,
});
export const setProfitData = (data) => ({
  type: SET_PROFIT_DATA,
  payload: data,
});

export const onPressTopProductDropDown = () => (disptch) => {
  disptch({
    type: ON_PRESS_TOP_PRODUCT_DROPDOWN,
  });
};

export const onPressReferralsDropDown = () => (disptch) => {
  disptch({
    type: ON_PRESS_REFERRALS_DROPDOWN,
  });
};

export const onPressTotalRevenueDropDown = () => (disptch) => {
  disptch({
    type: ON_PRESS_TOTAL_REVENUE_DROPDOWN,
  });
};

export const onPressDataManagedDropDown = () => (disptch) => {
  disptch({
    type: ON_PRESS_DATA_MANAGED_DROPDOWN,
  });
};

export const onPressRecentChatDropDown = () => (disptch) => {
  disptch({
    type: ON_PRESS_RECENT_CHAT_DROPDOWN,
  });
};

export const facebookProgressBar = () => (disptch, getState) => {
  var facebookIntervalId = setInterval(() => {
    const { facebookShowProgressBar } = getState().analyticalReducer;
    var facebookShow = facebookShowProgressBar + 1;

    disptch({
      type: FACEBOOK_PROGRESS_BAR,
      payload: facebookShow,
    });
    if (facebookShowProgressBar > 87) {
      clearInterval(facebookIntervalId);
    }
  }, 10);
};

export const twitterProgressBar = () => (disptch, getState) => {
  var twitterIntervalId = setInterval(() => {
    const { twitterShowProgressBar } = getState().analyticalReducer;
    var twitterShow = twitterShowProgressBar + 1;
    disptch({
      type: TWITTER_PROGRESS_BAR,
      payload: twitterShow,
    });
    if (twitterShowProgressBar > 34) {
      clearInterval(twitterIntervalId);
    }
  }, 10);
};

export const searchProgressBar = () => (disptch, getState) => {
  var searchIntervalId = setInterval(() => {
    const { searchShowProgressBar } = getState().analyticalReducer;
    var searchShow = searchShowProgressBar + 1;
    disptch({
      type: SEARCH_PROGRESS_BAR,
      payload: searchShow,
    });
    if (searchShowProgressBar > 54) {
      clearInterval(searchIntervalId);
    }
  }, 10);
};

export const affiliatesProgressBar = () => (disptch, getState) => {
  var affiliatesIntervalId = setInterval(() => {
    const { affiliatesShowProgressBar } = getState().analyticalReducer;
    var affiliatesShow = affiliatesShowProgressBar + 1;
    disptch({
      type: AFFILIATES_PROGRESS_BAR,
      payload: affiliatesShow,
    });
    if (affiliatesShowProgressBar > 64) {
      clearInterval(affiliatesIntervalId);
    }
  }, 10);
};
